

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/privacy/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.81029546.js","_app/immutable/chunks/scheduler.85e01571.js","_app/immutable/chunks/index.a7ffdff2.js","_app/immutable/chunks/Loading.27dbcd46.js","_app/immutable/chunks/index.282274ee.js"];
export const stylesheets = ["_app/immutable/assets/Loading.218e0f39.css"];
export const fonts = [];
